module.exports = __webpack_public_path__ + "assets/life_cel_v1.fd1eb08b.svg";